
import { Component, Prop, Vue } from "vue-property-decorator";
import { Query, ShiftOrderRecordDTO, StockShiftOrderExcelServiceProxy, StockShiftOrderServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
import { WarehouseAreaServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies';
import dayjs from 'dayjs';
import { exportShift } from '@/api/api';
const ssosp = new StockShiftOrderServiceProxy()
const ssoesp = new StockShiftOrderExcelServiceProxy()
const warehouseAreaServiceProxy = new WarehouseAreaServiceProxy()
@Component({
  components: {
  }
})
export default class TransferRecord extends Vue {
  get columns() {
    return [
      {
        title: this.$t('page_material_ware_move_orderName'),
        dataIndex: 'orderCode',
        ellipsis: true,
        key: 'orderCode',
        width: 150,
      },
      {
        title: this.$t('page_business_material_code'),
        dataIndex: 'materialCode',
        ellipsis: true,
        key: 'materialCode',
        width: 150,
      },
      {
        title: this.$t('page_business_material_name'),
        dataIndex: 'materialName',
        ellipsis: true,
        key: 'materialName',
        width: 150,
      },
      {
        title: this.$t('page_control_standardModel'),
        dataIndex: 'materialStandardModel',
        ellipsis: true,
        key: 'materialStandardModel',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_unit'),
        dataIndex: 'materialUnit',
        ellipsis: true,
        key: 'materialUnit',
        width: 150,
      },
      {
        title: this.$t('page_material_ware_move_stockout'),
        dataIndex: 'stockOutType',
        ellipsis: true,
        key: 'stockOutType',
        width: 150
      },
      {
        title: this.$t('page_material_warehousing_area'),
        dataIndex: 'fromAreaName',
        ellipsis: true,
        key: 'fromAreaName',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_location'),
        dataIndex: 'fromLocationName',
        ellipsis: true,
        key: 'fromLocationName',
        width: 150,
      },
      {
        title: this.$t('page_material_ware_move_shiftNum'),
        dataIndex: 'shiftNum',
        ellipsis: true,
        key: 'shiftNum',
        width: 150,
      },
      {
        title: this.$t('page_material_ware_out_stockNum'),
        dataIndex: 'fromStockNum',
        ellipsis: true,
        key: 'fromStockNum',
        width: 150,
      },
      {
        title: this.$t('page_material_ware_move_stockin'),
        dataIndex: 'stockInType',
        ellipsis: true,
        key: 'stockInType',
        width: 150
      },
      {
        title: this.$t('page_material_ware_move_toArea'),
        dataIndex: 'toAreaName',
        ellipsis: true,
        key: 'toAreaName',
        width: 150,
      },
      {
        title: this.$t('page_material_ware_move_toLocation'),
        dataIndex: 'toLocationName',
        ellipsis: true,
        key: 'toLocationName',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_to_stockNum'),
        dataIndex: 'toStockNum',
        ellipsis: true,
        key: 'toStockNum',
        width: 150,
      },
      {
        title: this.$t('page_material_ware_move_shiftDept'),
        dataIndex: 'shiftDept',
        ellipsis: true,
        key: 'shiftDept',
        width: 150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findDept(value) }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_move_shiftUser'),
        dataIndex: 'shiftUser',
        ellipsis: true,
        key: 'shiftUser',
        width: 150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findUser(value) }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_move_shiftTime'),
        dataIndex: 'shiftTime',
        ellipsis: true,
        key: 'shiftTime',
        width: 150,
        customRender: (value, _record, index) => {
          return (
            _record.id &&
            <span>
              { dayjs(value).format('YYYY-MM-DD HH:mm:ss') }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_move_remark'),
        dataIndex: 'remark',
        ellipsis: true,
        key: 'remark',
        width: 150,
      }
    ]
  };
  data = []
  @Prop({ default: () => [] }) readonly employeesList: any;
  @Prop({ default: () => [] }) readonly outTypeList: any;
  @Prop({ default: () => [] }) readonly stockInList: any;
  @Prop({ default: () => [] }) readonly listAllTree: any;
  height = 300
  selectedRowKeys = []
  pagination = {
    current: 1,
    size: 30
  }
  total = 0
  searchKey = ""
  areaId = ""
  idsArr = []
  selectId = ''

  updated(){
    const div = document.body.clientHeight
    this.height = div - 270
  }

  findUser(value){
    const user = this.employeesList.find(res => res.id === value)
    return user ? user.name : ""
  }

  findDept(value){
    const dept = this.listAllTree.find(res => res.key === value)
    return dept ? dept.title : ""
  }
  
  findOutType(value){
    const dept = this.outTypeList.find(res => res.id === value)
    return dept ? dept.name : ""
  }
  
  findstockIn(value){
    const dept = this.stockInList.find(res => res.id === value)
    return dept ? dept.name : ""
  }

  mounted(){
    this.getIds()
  }

  async getIds() {
    const res = await warehouseAreaServiceProxy.listWarehouseArea('')
    this.idsArr = res;
    this.selectId = res[0].id
    this.areaId = res[0].id
    this.getList()
  }

  changeId(val) {
    console.log(val)
    this.areaId = val
    this.getList()
  }

  getList(){
    // this.areaId = this.$route.query.materialId ? (this.$route.query.materialId).toString() : ""
    ssosp.pageStockShiftOrderRecord({areaId:this.selectId,keyWord: this.searchKey, query: this.pagination as Query} as ShiftOrderRecordDTO).then(res =>{
      // this.data = res.records

      let dataLength = res.records.length;
      let copy = JSON.parse(JSON.stringify(res.records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }

      this.data = JSON.parse(JSON.stringify(copy));

      this.total = Number(res.total)
    })

    // let dataLength = this.data.length;
    //   let copy = JSON.parse(JSON.stringify(this.data));
    //   let needPush = 0;
    //   if(dataLength < 30) {
    //     needPush = 30 - dataLength;
    //     for(var k=0; k<needPush; k++) {
    //       let obj = {  
    //         // id: 'none'
    //       }
    //       copy.push(obj)  
    //     }
    //   }

    //   this.data = JSON.parse(JSON.stringify(copy));
  }

  onSearch(value){
    this.pagination.current = 1
    this.searchKey = value
    this.getList()
  }

  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  handleTableChange(current: number, pageSize: number) {
    this.pagination.size = pageSize
    this.pagination.current = current
    this.getList()
  }

  handleExport(){
    exportShift(this.areaId).then(res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${this.$t('page_meterial_analysis_setting')}.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  render() {
    return (
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'} style="display:flex;justify-content: space-between;margin-top: 8px;">
          <div>
            <a-button type="primary" style="margin-right: 8px;" onClick={() => this.handleExport()}>{ this.$t('page_product_export') }</a-button>

            <a-select v-model={this.selectId} optionFilterProp="children" style="width: 140px; font-size: 13px;" onChange={this.changeId}>
            {this.idsArr.map((item) => {
              return (
                <a-select-option key={item.id} value={item.id}>
                  {item.name}
                </a-select-option>
              );
            })}
            </a-select>

            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_product_printing') }</a-button> */}
          </div>
          <div>
            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_my_document_advanced') }</a-button> */}
            <a-input-search style="width: 200px" enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner" style="height:100%">
          <ml-table
            pagination={false}
            columns={this.columns}
            dataSource={this.data}
            bordered
            scroll={{ y: this.height, x: 2350 }}
          >
          </ml-table>
          <a-pagination
            style="position:absolute;bottom: 4px;right: 20px"
            show-total={total => `${ this.showTotal(total) }`}
            current={this.pagination.current}
            total={this.total}
            pageSize={this.pagination.size}
            on-change={this.handleTableChange}
            on-showSizeChange={this.handleTableChange}
          />
        </div>
      </blank-view>
    )
  }
}